class searchDrawerTrigger extends HTMLElement {
constructor() {
    super();
    this.searchDrawer = document.querySelector('#search-drawer-model');
    this.boundOpenDrawer = this.openDrawer.bind(this);
    this.boundHandleKeyDown = this.handleKeyDown.bind(this);
    this.listenersConnected = false;
  }

  connectedCallback() {
    if (this.listenersConnected) return;
    this.searchDrawer = document.querySelector('#search-drawer-model');
    if (!this.searchDrawer) return;
    this.addEventListener("click", this.boundOpenDrawer);
    this.addEventListener("keydown", this.boundHandleKeyDown);
    this.listenersConnected = true;
  }

  disconnectedCallback() {
    if (!this.listenersConnected) return;
    this.removeEventListener("click", this.boundOpenDrawer);
    this.removeEventListener("keydown", this.boundHandleKeyDown);
    this.listenersConnected = false;
  }

  handleKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.openDrawer(event);
    }
  }

  openDrawer(event) {
    if (!this.searchDrawer) return;
    this.searchDrawer.openDrawer?.(event?.currentTarget || this);
  }
}

customElements.define("search-drawer", searchDrawerTrigger);

class searchModalDialog extends HTMLElement{
      constructor() {
        super();
        this.closeBtns = this.querySelectorAll('[data-drawer-close]');
        this.suggestionsContent = this.querySelector('[data-suggestion-content]');
        this.resultsContainer = this.querySelector('[data-predictive-search-body]');
        this.loadingContainer = this.querySelector('[data-loading-content]');
        this.clear = this.querySelector('[data-clear-input]');
        this.abortController = null;
        this.requestToken = 0;
        this.focusGeneration = 0;
        this.activeOpener = null;
        this.pendingFocusTransitionElement = null;
        this.pendingFocusTransitionHandler = null;
        this.pendingFocusFallbackTimer = null;
        this.pendingFocusFrame = null;
        this.focusedGeneration = null;
        this.boundHandleKeyDown = this.handleKeyDown.bind(this);
        this.keydownListenerConnected = false;
        if(this.closeBtn){
          this.closeBtn.addEventListener("click",this.closeDrawer.bind(this))
        }
        Array.from(this.closeBtns).forEach(function(closeBtn){
          closeBtn.addEventListener("click",function(event){
            event.preventDefault();
            this.closeDrawer();
          }.bind(this))
        }.bind(this))
        this.input = this.querySelector('input[type="search"]');

        if (this.input) {
          this.debouncedOnChange = this.debounce(this.onChange.bind(this), 300);
          this.input.addEventListener('input', () => {
            if (this.input.value.trim() === '') {
              this.debouncedOnChange.cancel();
              this.clearSearchResults();
              return;
            }

            this.prepareSearch();
            this.debouncedOnChange();
          });
          if (this.clear) {
          this.clear.addEventListener(
            'click',function(event){
              event.preventDefault();
              this.debouncedOnChange.cancel();
              this.input.value = '';
              this.clearSearchResults();
              this.focusInput();
            }.bind(this));
        }
        }
      }

      connectedCallback() {
        if (this.keydownListenerConnected) return;
        document.addEventListener('keydown', this.boundHandleKeyDown);
        this.keydownListenerConnected = true;
      }

      disconnectedCallback() {
        this.debouncedOnChange?.cancel();
        this.cancelPendingFocus();
        this.focusGeneration += 1;
        this.focusedGeneration = null;
        this.activeOpener = null;
        this.invalidateCurrentRequest();
        if (this.keydownListenerConnected) {
          document.removeEventListener('keydown', this.boundHandleKeyDown);
          this.keydownListenerConnected = false;
        }
        if (this.classList.contains("is-visible")) {
          this.classList.remove("is-visible");
          document.body.classList.remove("overflow-hidden");
          if (typeof removeTrapFocus === "function") {
            removeTrapFocus();
          }
        }
      }

      openDrawer(opener) {
        this.cancelPendingFocus();
        const focusGeneration = ++this.focusGeneration;
        this.focusedGeneration = null;
        this.activeOpener = opener?.isConnected ? opener : null;
        this.classList.add("is-visible");
        document.body.classList.add("overflow-hidden");

        if (!this.isCurrentOpenFocus(focusGeneration)) return;
        if (typeof removeTrapFocus === "function") {
          removeTrapFocus();
        }
        this.focusInputWhenReady(focusGeneration);
      }
    
      closeDrawer(){
        this.cancelPendingFocus();
        const focusGeneration = ++this.focusGeneration;
        this.focusedGeneration = null;
        const opener = this.activeOpener;
        this.activeOpener = null;
        this.classList.remove("is-visible");
        this.debouncedOnChange?.cancel();
        if (this.input) {
          this.input.value = '';
        }
        this.clearSearchResults();
        document.querySelector("body").classList.remove("overflow-hidden");
        if (typeof removeTrapFocus === "function") {
          removeTrapFocus();
        }

        if (
          focusGeneration === this.focusGeneration
          && this.isConnected
          && !this.classList.contains("is-visible")
          && this.isFocusableOpener(opener)
        ) {
          opener.focus();
        }
      }

      isCurrentOpenFocus(focusGeneration) {
        return focusGeneration === this.focusGeneration
          && this.isConnected
          && this.classList.contains("is-visible");
      }

      isFocusableInput(focusGeneration) {
        if (
          !this.isCurrentOpenFocus(focusGeneration)
          || !this.input
          || !this.contains(this.input)
          || this.input.disabled
          || this.input.hidden
          || this.input.type === 'hidden'
          || this.input.closest('[hidden]')
          || typeof this.input.focus !== "function"
        ) return false;

        const style = window.getComputedStyle(this.input);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }

      isFocusableOpener(opener) {
        if (
          !opener
          || !opener.isConnected
          || opener.hidden
          || opener.closest?.('[hidden]')
          || opener.hasAttribute?.('disabled')
          || typeof opener.focus !== "function"
        ) return false;

        const style = window.getComputedStyle(opener);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }

      cancelPendingFocus() {
        if (this.pendingFocusTransitionElement && this.pendingFocusTransitionHandler) {
          this.pendingFocusTransitionElement.removeEventListener(
            'transitionend',
            this.pendingFocusTransitionHandler
          );
          this.pendingFocusTransitionElement.removeEventListener(
            'transitioncancel',
            this.pendingFocusTransitionHandler
          );
        }
        if (this.pendingFocusFallbackTimer !== null) {
          window.clearTimeout(this.pendingFocusFallbackTimer);
        }
        if (this.pendingFocusFrame !== null) {
          window.cancelAnimationFrame(this.pendingFocusFrame);
        }
        this.pendingFocusTransitionElement = null;
        this.pendingFocusTransitionHandler = null;
        this.pendingFocusFallbackTimer = null;
        this.pendingFocusFrame = null;
      }

      parseTransitionTimes(value) {
        return value.split(',').map((time) => {
          const normalizedTime = time.trim().toLowerCase();
          const parsedTime = Number.parseFloat(normalizedTime);
          if (!Number.isFinite(parsedTime)) return 0;
          return normalizedTime.endsWith('ms') ? parsedTime : parsedTime * 1000;
        });
      }

      getMaxTransitionTime(element) {
        const style = window.getComputedStyle(element);
        const durations = this.parseTransitionTimes(style.transitionDuration);
        const delays = this.parseTransitionTimes(style.transitionDelay);
        const transitionCount = Math.max(durations.length, delays.length);
        let maxTransitionTime = 0;

        for (let index = 0; index < transitionCount; index += 1) {
          const duration = durations[index % durations.length] || 0;
          const delay = delays[index % delays.length] || 0;
          maxTransitionTime = Math.max(maxTransitionTime, duration + delay);
        }

        return Math.max(0, maxTransitionTime);
      }

      completePendingFocus(focusGeneration) {
        if (this.focusedGeneration === focusGeneration) return true;
        if (!this.focusInput(focusGeneration)) return false;
        this.focusedGeneration = focusGeneration;
        this.cancelPendingFocus();
        return true;
      }

      focusInputWhenReady(focusGeneration) {
        if (!this.isCurrentOpenFocus(focusGeneration)) return;
        if (this.completePendingFocus(focusGeneration)) return;

        const transitionElement = this;
        const handleFocusTransition = () => {
          if (!this.isCurrentOpenFocus(focusGeneration)) {
            this.cancelPendingFocus();
            return;
          }
          this.completePendingFocus(focusGeneration);
        };

        this.pendingFocusTransitionElement = transitionElement;
        this.pendingFocusTransitionHandler = handleFocusTransition;
        transitionElement.addEventListener('transitionend', handleFocusTransition);
        transitionElement.addEventListener('transitioncancel', handleFocusTransition);

        const maxTransitionTime = this.getMaxTransitionTime(transitionElement);
        if (maxTransitionTime > 0) {
          this.pendingFocusFallbackTimer = window.setTimeout(() => {
            this.pendingFocusFallbackTimer = null;
            if (!this.isCurrentOpenFocus(focusGeneration)) {
              this.cancelPendingFocus();
              return;
            }
            this.completePendingFocus(focusGeneration);
          }, maxTransitionTime + 50);
          return;
        }

        this.pendingFocusFrame = window.requestAnimationFrame(() => {
          this.pendingFocusFrame = null;
          if (!this.isCurrentOpenFocus(focusGeneration)) {
            this.cancelPendingFocus();
            return;
          }
          this.completePendingFocus(focusGeneration);
        });
      }

      focusInput(focusGeneration = this.focusGeneration) {
        if (!this.isFocusableInput(focusGeneration)) return false;
        this.input.focus();
        this.input.select?.();
        return document.activeElement === this.input;
      }
  
       handleKeyDown(event) {
        if (!this.isConnected || !this.classList.contains("is-visible")) return;
        if (event.key === 'Escape') {
          this.closeDrawer(event); // Call closeDrawer when Escape is pressed
          return;
        }
        if (event.key !== 'Tab') return;

        // Visibility transitions and predictive results can change these boundaries.
        const focusable = getFocusableElements(this).filter((element) =>
          element.tabIndex >= 0
          && !element.matches(':disabled')
          && !element.closest('[hidden], [inert]')
        );
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;
        if (!this.contains(active) || (event.shiftKey ? active === first : active === last)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }
    
      debounce(fn, delay) {
        var timer = null;
        const debounced = function () {
          var context = this,
            args = arguments;
          clearTimeout(timer);
          timer = setTimeout(function () {
            fn.apply(context, args);
          }, delay);
        };
        debounced.cancel = function () {
          clearTimeout(timer);
          timer = null;
        };
        return debounced;
      }

      normalizeSearchTerm(value) {
        return value.trim().replace(/\s+/g, ' ').toLowerCase();
      }

      cancelCurrentRequest() {
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
      }

      invalidateCurrentRequest() {
        this.requestToken += 1;
        this.cancelCurrentRequest();
      }

      clearDynamicResults() {
        if (this.resultsContainer) {
          this.resultsContainer.classList.add('hidden');
          this.resultsContainer.innerHTML = '';
        }
      }

      clearSearchResults() {
        this.invalidateCurrentRequest();
        this.searchTerm = '';
        this.clearDynamicResults();
        if (this.loadingContainer) {
          this.loadingContainer.classList.add('hidden');
        }
        if (this.suggestionsContent) {
          this.suggestionsContent.classList.remove('hidden');
        }
      }

      prepareSearch() {
        this.invalidateCurrentRequest();
        this.clearDynamicResults();
        if (this.suggestionsContent) {
          this.suggestionsContent.classList.add('hidden');
        }
        if (this.loadingContainer) {
          this.loadingContainer.classList.remove('hidden');
        }
      }

      onChange() {
        this.searchTerm = this.input.value.trim();
        if (this.searchTerm === '') {
          this.clearSearchResults();
          return;
        }

        this.getSearchResults();
      }

    
      isCurrentRequest(requestToken, queryKey, controller) {
        return requestToken === this.requestToken
          && controller === this.abortController
          && this.classList.contains("is-visible")
          && queryKey === this.normalizeSearchTerm(this.input.value);
      }

      async getSearchResults() {
        const searchTerm = this.input.value.trim();
        const queryKey = this.normalizeSearchTerm(searchTerm);
        this.cancelCurrentRequest();
        const requestToken = ++this.requestToken;
        const controller = new AbortController();
        this.abortController = controller;

        try {
          const response = await fetch(
            `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`,
            { signal: controller.signal }
          );

          if (!response.ok) {
            throw new Error(`Predictive search request failed: ${response.status}`);
          }

          const text = await response.text();
          if (!this.isCurrentRequest(requestToken, queryKey, controller)) return;

          const resultWrapper = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-result-wrapper]');
          if (!resultWrapper) {
            throw new Error('Predictive search result wrapper not found');
          }

          this.resultsContainer.innerHTML = resultWrapper.innerHTML;
          if (
            typeof productCardHoverPreloader !== 'undefined'
            && typeof productCardHoverPreloader.observe === 'function'
          ) {
            productCardHoverPreloader.observe(this.resultsContainer);
          }
          this.resultsContainer.classList.remove('hidden');
        } catch (error) {
          if (error?.name === 'AbortError') return;
          if (!this.isCurrentRequest(requestToken, queryKey, controller)) return;
          console.error(error);
        } finally {
          if (requestToken === this.requestToken && controller === this.abortController) {
            this.abortController = null;
            if (this.loadingContainer) {
              this.loadingContainer.classList.add('hidden');
            }
          }
        }
      }

     
    }
customElements.define("search-modal-dialog", searchModalDialog );

class predictiveSearchTab extends HTMLElement{
  constructor() {
    super();
    this.searchDrawerModel = this.closest('#search-drawer-model');
    if(!this.searchDrawerModel) return ;
    this.activeTab = this.searchDrawerModel.querySelector('.predictive-search-tab.is-active');
    this.activeTabContent = this.searchDrawerModel.querySelector('.predictive-search-tab-item.active');
    this.tabs = this.querySelectorAll('.predictive-search-tab');
    Array.from(this.tabs).forEach(function(tab){
      if(tab.classList.contains('is-active')) return false;
      tab.addEventListener("click",function(event){
        event.preventDefault();
        this.tabContent = this.searchDrawerModel.querySelector(tab.dataset.tab);
        if(this.tabContent){
          this.closeExisting();
          tab.classList.add('is-active');
          this.tabContent.classList.add('is-active');
          this.tabContent.style.display = 'block';
          this.activeTab = tab;
          this.activeTabContent = this.tabContent;
        }
      }.bind(this))
    }.bind(this))
    if(this.tabs.length > 0){
      this.tabs[0].click();
    }
  }
  closeExisting(){
    if(this.activeTab){
      this.activeTab.classList.remove('is-active')
    }
    if(this.activeTabContent){
      this.activeTabContent.classList.remove('is-active');
      this.activeTabContent.style.display = 'none';
    }
  }
}

customElements.define("predictive-search-tab", predictiveSearchTab);

